import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetPaymentPlans = (studentId) => {
    const enabled = studentId !== undefined && studentId !== null && `${studentId}` !== "";

    const {
        isLoading, data: paymentPlans, error,
        refetch: refetchEndpoint, isRefetching,
    } = useQuery({
        queryKey: ["student/PaymentPlans", studentId],
        queryFn: ({ queryKey }) => {
            const [, sid] = queryKey;
            if (sid === undefined || sid === null || `${sid}` === "") {
                return Promise.resolve(null);
            }
            return axiosManager
                .get$(`/parent/api/students/${sid}/PaymentPlans`)
                .then((r) => r?.data);
        },
        retry: 0,
        enabled,
    });

    const refetch = () => {
        if (enabled) refetchEndpoint();
    };

    return {
        isLoading,
        isRefetching,
        paymentPlans,
        error,
        refetch,
    };
};
